(function () {
  if (window.__priceFacetV2Loaded) return;
  window.__priceFacetV2Loaded = true;

  function stripHtml(s) {
    return String(s || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  }

  function toNumber(v) {
    var s = String(v ?? '').trim();
    s = s.replace(/\s|\u00A0/g, '');
    s = s.replace(/\*/g, '');
    s = s.replace(/[^\d.,-]/g, '');
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  function formatNumber(locale, n, decimals) {
    try {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(n);
    } catch (e) {
      return String(n);
    }
  }

  function renderMoney(locale, currencyCode, moneyFormat, n) {
    var fmt = stripHtml(moneyFormat);
    n = Math.max(0, Number(n) || 0);

    var amount2 = formatNumber(locale, n, 2);
    var amount0 = formatNumber(locale, Math.round(n), 0);

    if (!fmt) {
      try {
        if (currencyCode) {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode
          }).format(n);
        }
      } catch (e) {}
      return amount2;
    }

    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount2)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amount2)
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, amount2)
      .replace(/\{\{\s*amount\s*\}\}/g, amount2)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amount0)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount0);
  }

  function getQueryParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name);
    } catch (e) {
      return null;
    }
  }

  function readPriceParams() {
    var gte = getQueryParam('filter.v.price.gte');
    var lte = getQueryParam('filter.v.price.lte');

    return {
      gte: gte != null && gte !== '' ? toNumber(gte) : null,
      lte: lte != null && lte !== '' ? toNumber(lte) : null
    };
  }

  function submitFacetForm(el) {
    if (!el) return;

    var form = el.closest('form');
    if (!form) return;

    if (form.id === 'FacetFiltersFormMobile') {
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function PriceRangeV2(root) {
    this.root = root;
    this.minThumb = root.querySelector('.price-range-v2__thumb--min');
    this.maxThumb = root.querySelector('.price-range-v2__thumb--max');
    this.fill = root.querySelector('.price-range-v2__fill');

    this.minInput = document.getElementById(root.dataset.minInput);
    this.maxInput = document.getElementById(root.dataset.maxInput);

    this.locale = root.dataset.locale || 'de-DE';
    this.currencyCode = root.dataset.currencyCode || '';
    this.moneyFormat = root.dataset.moneyFormat || '';
    this.rangeMaxAttr = root.dataset.rangeMax || '';

    this._isDragging = false;
    this._lastMoved = null;
    this._lastStableMin = 0;
    this._lastStableMax = 0;

    this._boundOnThumbInput = this.onThumbInput.bind(this);
    this._boundOnThumbPointerDown = this.onThumbPointerDown.bind(this);
    this._boundOnThumbPointerUp = this.onThumbPointerUp.bind(this);
    this._boundOnThumbChangeMin = this.onThumbChangeMin.bind(this);
    this._boundOnThumbChangeMax = this.onThumbChangeMax.bind(this);
    this._boundOnTextInput = this.onTextInput.bind(this);
    this._boundOnTextCommit = this.onTextCommit.bind(this);

    this.attach();
    this.refresh();
  }

  PriceRangeV2.prototype.getForm = function () {
    return this.minInput ? this.minInput.closest('form') : null;
  };

  PriceRangeV2.prototype.isMobile = function () {
    var form = this.getForm();
    return !!(form && form.id === 'FacetFiltersFormMobile');
  };

  PriceRangeV2.prototype.attach = function () {
    if (!this.minThumb || !this.maxThumb || !this.fill || !this.minInput || !this.maxInput) {
      return;
    }

    this.detach();

    this.minThumb.addEventListener('input', this._boundOnThumbInput);
    this.maxThumb.addEventListener('input', this._boundOnThumbInput);

    this.minThumb.addEventListener('pointerdown', this._boundOnThumbPointerDown);
    this.maxThumb.addEventListener('pointerdown', this._boundOnThumbPointerDown);

    this.minThumb.addEventListener('pointerup', this._boundOnThumbPointerUp);
    this.maxThumb.addEventListener('pointerup', this._boundOnThumbPointerUp);

    this.minThumb.addEventListener('change', this._boundOnThumbChangeMin);
    this.maxThumb.addEventListener('change', this._boundOnThumbChangeMax);

    this.minInput.addEventListener('input', this._boundOnTextInput);
    this.maxInput.addEventListener('input', this._boundOnTextInput);

    this.minInput.addEventListener('blur', this._boundOnTextCommit);
    this.maxInput.addEventListener('blur', this._boundOnTextCommit);

    this.minInput.addEventListener('keydown', this._boundOnTextCommit);
    this.maxInput.addEventListener('keydown', this._boundOnTextCommit);
  };

  PriceRangeV2.prototype.detach = function () {
    if (!this.minThumb || !this.maxThumb || !this.minInput || !this.maxInput) return;

    this.minThumb.removeEventListener('input', this._boundOnThumbInput);
    this.maxThumb.removeEventListener('input', this._boundOnThumbInput);

    this.minThumb.removeEventListener('pointerdown', this._boundOnThumbPointerDown);
    this.maxThumb.removeEventListener('pointerdown', this._boundOnThumbPointerDown);

    this.minThumb.removeEventListener('pointerup', this._boundOnThumbPointerUp);
    this.maxThumb.removeEventListener('pointerup', this._boundOnThumbPointerUp);

    this.minThumb.removeEventListener('change', this._boundOnThumbChangeMin);
    this.maxThumb.removeEventListener('change', this._boundOnThumbChangeMax);

    this.minInput.removeEventListener('input', this._boundOnTextInput);
    this.maxInput.removeEventListener('input', this._boundOnTextInput);

    this.minInput.removeEventListener('blur', this._boundOnTextCommit);
    this.maxInput.removeEventListener('blur', this._boundOnTextCommit);

    this.minInput.removeEventListener('keydown', this._boundOnTextCommit);
    this.maxInput.removeEventListener('keydown', this._boundOnTextCommit);
  };

  PriceRangeV2.prototype.ensureNumericRangeAttrs = function () {
    var maxN = toNumber(this.rangeMaxAttr) || 1;
    maxN = Math.max(1, Math.ceil(maxN));

    this.minThumb.min = '0';
    this.maxThumb.min = '0';
    this.minThumb.max = String(maxN);
    this.maxThumb.max = String(maxN);
  };

  PriceRangeV2.prototype.clampPair = function () {
    var a = toNumber(this.minThumb.value);
    var b = toNumber(this.maxThumb.value);

    if (a > b) {
      if (this._lastMoved === 'min') {
        this.maxThumb.value = String(a);
      } else if (this._lastMoved === 'max') {
        this.minThumb.value = String(b);
      } else {
        this.maxThumb.value = String(a);
      }
    }
  };

  PriceRangeV2.prototype.updateFill = function () {
    var rangeMin = toNumber(this.minThumb.min) || 0;
    var rangeMax = toNumber(this.minThumb.max) || 1;

    var a = toNumber(this.minThumb.value);
    var b = toNumber(this.maxThumb.value);

    var p1 = rangeMax <= rangeMin ? 0 : ((a - rangeMin) / (rangeMax - rangeMin)) * 100;
    var p2 = rangeMax <= rangeMin ? 0 : ((b - rangeMin) / (rangeMax - rangeMin)) * 100;

    this.fill.style.left = p1 + '%';
    this.fill.style.width = Math.max(0, p2 - p1) + '%';
  };

  PriceRangeV2.prototype.paintFormattedValues = function () {
    var a = renderMoney(this.locale, this.currencyCode, this.moneyFormat, toNumber(this.minThumb.value));
    var b = renderMoney(this.locale, this.currencyCode, this.moneyFormat, toNumber(this.maxThumb.value));

    this.minInput.value = stripHtml(a);
    this.maxInput.value = stripHtml(b);
  };

  PriceRangeV2.prototype.paintRawValues = function () {
    this.minInput.value = String(Math.round(toNumber(this.minThumb.value)));
    this.maxInput.value = String(Math.round(toNumber(this.maxThumb.value)));
  };

  PriceRangeV2.prototype.onThumbPointerDown = function (e) {
    this._isDragging = true;
    this._lastMoved = e.target === this.minThumb ? 'min' : 'max';
  };

  PriceRangeV2.prototype.onThumbPointerUp = function () {
    var self = this;
    setTimeout(function () {
      self._isDragging = false;
    }, 0);
  };

  PriceRangeV2.prototype.onThumbInput = function (e) {
    this._lastMoved = e.target === this.minThumb ? 'min' : 'max';

    this.ensureNumericRangeAttrs();
    this.clampPair();
    this.updateFill();

    this._lastStableMin = toNumber(this.minThumb.value);
    this._lastStableMax = toNumber(this.maxThumb.value);

    if (this.isMobile()) {
      this.paintRawValues();
    } else {
      this.paintFormattedValues();
    }
  };

  PriceRangeV2.prototype.onThumbChangeMin = function () {
    var currentMin = toNumber(this.minThumb.value);
    var currentMax = toNumber(this.maxThumb.value);

    if (!currentMin && this._lastStableMin > 0 && this._lastMoved === 'min') {
      this.minThumb.value = String(this._lastStableMin);
    }

    if (!currentMax && this._lastStableMax > 0) {
      this.maxThumb.value = String(this._lastStableMax);
    }

    this.paintRawValues();

    if (!this.isMobile()) {
      submitFacetForm(this.minInput);
    }
  };

  PriceRangeV2.prototype.onThumbChangeMax = function () {
    var currentMin = toNumber(this.minThumb.value);
    var currentMax = toNumber(this.maxThumb.value);

    if (!currentMax && this._lastStableMax > 0 && this._lastMoved === 'max') {
      this.maxThumb.value = String(this._lastStableMax);
    }

    if (!currentMin && this._lastStableMin > 0) {
      this.minThumb.value = String(this._lastStableMin);
    }

    this.paintRawValues();

    if (!this.isMobile()) {
      submitFacetForm(this.maxInput);
    }
  };

  PriceRangeV2.prototype.onTextInput = function () {
    if (this.minInput.value !== '') {
      this.minThumb.value = String(Math.round(toNumber(this.minInput.value)));
    }

    if (this.maxInput.value !== '') {
      this.maxThumb.value = String(Math.round(toNumber(this.maxInput.value)));
    }

    this.ensureNumericRangeAttrs();
    this.clampPair();
    this.updateFill();

    this._lastStableMin = toNumber(this.minThumb.value);
    this._lastStableMax = toNumber(this.maxThumb.value);
  };

  PriceRangeV2.prototype.onTextCommit = function (e) {
    if (e && e.type === 'keydown' && e.key !== 'Enter') return;
    if (e && e.type === 'keydown') e.preventDefault();

    if (this.minInput.value !== '') {
      this.minThumb.value = String(Math.round(toNumber(this.minInput.value)));
    }

    if (this.maxInput.value !== '') {
      this.maxThumb.value = String(Math.round(toNumber(this.maxInput.value)));
    }

    this.ensureNumericRangeAttrs();
    this.clampPair();
    this.updateFill();
    this.paintRawValues();

    this._lastStableMin = toNumber(this.minThumb.value);
    this._lastStableMax = toNumber(this.maxThumb.value);

    if (!this.isMobile()) {
      submitFacetForm(this.minInput);
    }
  };

  PriceRangeV2.prototype.refresh = function () {
    if (!this.minThumb || !this.maxThumb || !this.fill || !this.minInput || !this.maxInput) return;
    if (this._isDragging) return;

    var url = readPriceParams();
    var maxBound = toNumber(this.rangeMaxAttr) || 1;

    this.ensureNumericRangeAttrs();

    var vMin = url.gte != null ? url.gte : 0;
    var vMax = url.lte != null ? url.lte : maxBound;

    this.minThumb.value = String(Math.round(vMin));
    this.maxThumb.value = String(Math.round(vMax));

    this.clampPair();
    this.updateFill();

    this._lastStableMin = toNumber(this.minThumb.value);
    this._lastStableMax = toNumber(this.maxThumb.value);

    if (this.isMobile()) {
      this.paintRawValues();
    } else {
      var hasPriceFilter = url.gte != null || url.lte != null;
      if (hasPriceFilter) {
        this.paintFormattedValues();
      } else {
        this.minInput.value = '';
        this.maxInput.value = '';
        this.minInput.placeholder = '0';
        this.maxInput.placeholder = String(Math.round(maxBound));
      }
    }
  };

  var manager = {
    map: new WeakMap(),
    timer: 0,

    initAll: function () {
      var nodes = document.querySelectorAll('.price-range-v2');

      nodes.forEach(function (root) {
        var inst = manager.map.get(root);

        if (!inst) {
          inst = new PriceRangeV2(root);
          manager.map.set(root, inst);
        } else {
          inst.attach();
          inst.refresh();
        }
      });
    },

    refreshAll: function () {
      var nodes = document.querySelectorAll('.price-range-v2');

      nodes.forEach(function (root) {
        var inst = manager.map.get(root);

        if (inst) {
          inst.refresh();
        } else {
          inst = new PriceRangeV2(root);
          manager.map.set(root, inst);
        }
      });
    },

    schedule: function () {
      clearTimeout(manager.timer);
      manager.timer = setTimeout(function () {
        manager.refreshAll();
      }, 250);
    }
  };

  window.PriceRangeV2 = manager;

  function observeProductGridChanges() {
    if (!window.MutationObserver) return;

    var target = document.getElementById('ProductGridContainer');
    if (!target) return;

    var mo = new MutationObserver(function () {
      manager.schedule();
    });

    mo.observe(target, { childList: true, subtree: true });
  }

  function boot() {
    manager.initAll();
    observeProductGridChanges();
    manager.schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('popstate', function () {
    manager.schedule();
  });
})();
